import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { StateController } from '../state';
import { marketplaceLogo } from '../svg';

@customElement('umb-market-header')
export class UmbMarketHeader extends LitElement {
  constructor() {
    super();
    if (StateController.isEmbedView) this.style.display = 'none';
  }

  connectedCallback(): void {
    super.connectedCallback();

    if (StateController.current.isBackoffice) {
      this.setAttribute('backoffice', '');
    }
  }

  render() {
    return html`
      <header>
        <div class="logo">
          <a href="/" aria-label="Home"> ${marketplaceLogo} </a>
        </div>
        <umb-market-search></umb-market-search>
        <div></div>
      </header>
      <umb-market-categories
        .categories=${StateController.current.categories}
      ></umb-market-categories>
    `;
  }

  static styles = css`
    :host {
      display: block;
      padding: var(--l-spacer) var(--s-spacer) 0;
      max-width: var(--max-width);
      margin: 0 auto;
    }

    header {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 30px;
    }

    :host([backoffice]) header {
      flex-direction: row;
      justify-content: space-between;
    }

    .logo {
      display: var(--header-logo-display, flex);
      flex: 0 1 0%;
      margin: 0 auto 0 0;
      max-width: 70%;
      align-items: center;
    }

    :host([backoffice]) .logo {
      display: none;
    }

    a {
      display: inline-flex;
    }

    img {
      max-width: 100%;
    }

    div {
      display: none;
    }

    @media (min-width: 767px) {
      :host {
        padding: var(--xl-spacer) var(--m-spacer) var(--m-spacer);
      }

      header {
        flex-direction: row;
        justify-content: space-between;
      }

      :host([backoffice]) header {
        justify-content: center;
      }

      .logo {
        margin-left: 0;
        margin-right: 64px;
      }
    }

    @media (min-width: 1300px) {
      div {
        display: none;
      }

      .logo {
        margin-right: 0;
        flex: 1;
      }
    }
  `;
}
